/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
import type { IconSVGProps } from '../../components/icon/Icon'
const edit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m14.06 5.134-8.764 8.764L1 15l1.101-4.296 8.764-8.765m3.195 3.195.258-.258a2.263 2.263 0 0 0 .022-3.216 2.264 2.264 0 0 0-3.217.022l-.258.257m3.195 3.195L10.865 1.94"
    />
  </svg>
)
export default edit
